export const setAiAssistant = (aiAssistant) => ({
    type: 'SET_AI_ASSISTANT',
    payload: aiAssistant,
});